export default "__VITE_ASSET__1u0ECDAa__"